import * as ActionTypes from 'actions/partnerPlanAdmin'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  partnerPlanOverviewPages: [],
  partnerPlanUploadLogs: [],
  selectedPlanOverviewPage: {},
  partnerPlanOverviewPage: {},
}

// Updates error message to notify about the failed fetches.
export default function partnerPlanAdmin(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLANADMIN_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.PARTNERPLANADMIN_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlanOverviewPages: action.item,
      }
    case ActionTypes.PARTNERPLANADMIN_SELECTEDOVERVIEWPAGE:
      return {
        ...state,
        selectedPlanOverviewPage: action.item,
      }
    case ActionTypes.PARTNERPLANADMIN_OVERVIEWPAGE:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlanOverviewPage: action.item,
      }
    case ActionTypes.PARTNERPLANADMIN_UPLOADLOGRECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlanUploadLogs: action.item,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlanAdmin.js